const TAB_ID_KEY = "app:tab-id";

export function getTabId(forceRefresh: boolean = false): string {
	let tabId = sessionStorage.getItem(TAB_ID_KEY);

	if (!tabId || forceRefresh) {
		tabId = crypto.randomUUID();
		sessionStorage.setItem(TAB_ID_KEY, tabId);
	}

	return tabId;
}
